import { useTranslation } from "react-i18next";
import { Chip, Divider } from "@heroui/react";
import PowerPickChart from "./charts/powerPickChart";
import Box from "/app/src/components/generic/components/box";

/**
 * Generic Connection Status Component
 * @param {Object} props
 * @param {string} props.connectionName - Name of the connection
 * @param {Object} props.data - Data for the chart
 * @param {boolean} props.isConnected - Connection status
 * @returns JSX.Element
 */
function ConnectionStatusCard({ connectionName, data, isConnected }) {
  const { t } = useTranslation();
  return (
    <Box>
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-neutral-charcoal font-archivo text-lg mb-0 font-medium">
            {connectionName}
          </h3>
          <h4 className="text-neutral-charcoal font-archivo text-sm mb-0 font-medium">
            {t("translation:connection_status")}
          </h4>
        </div>
      </div>
      <Divider className="my-4" />
      <div className="flex items-center justify-end">
        {isConnected ? (
          <Chip variant="dot" color="success" size="sm">
            {t("translation:connected")}
          </Chip>
        ) : (
          <Chip variant="dot" color="danger" size="sm">
            {t("translation:not_connected")}
          </Chip>
        )}
      </div>
      <PowerPickChart data={data} />
    </Box>
  );
}

export default ConnectionStatusCard;
